export default __webpack_public_path__ + "static/media/7minfitness@2x.f1fb877f.jpg";